<app-status-badge [status]="badgeStatus()" [label]="label()" [rounded]="true" />
